import React from 'react';
import { connect } from 'react-redux';
import formattedTotalCartPriceBeforeTax from '../../utils/formattedTotalCartPriceBeforeTax';
import {
  updateOrderSettingModalIsVisible,
  getTimeIntervalsDate,
} from '../OrderSetting/orderSettingActions';
import ReviewOrderButton from './ReviewOrderButton';
import { reviewOrder } from '../CartMenuSidebar/utils/reviewOrderValidation';
import useIsFoodRequired from '../../customHooks/useIsFoodRequired';
import { navigate } from 'gatsby';
import { isGuestOrderInfoClient } from '../../clientCustomizations';

const ReviewOrderButtonContainer = ({
  cartReducer,
  amountEditOrderConfig,
  updateOrderSettingModalIsVisible,
  orderSettingReducer,
  updateCartScreen,
}) => {
  const {
    availableTimes,
    interPickUpDetails,
    deliveryDetails,
    selectedDateTime,
    orderType,
    deliveryBusiness,
    dateTimeToShow,
    specialHours,
    interDeliveryDetails,
    interDropOffDetails,
    dropOffDetails,
  } = orderSettingReducer;

  const { products } = cartReducer;
  const { isFoodRequired } = useIsFoodRequired(products);
  const handleClick = () => {
    if (isGuestOrderInfoClient) {
      updateCartScreen('customer-info');
      navigate('/cart');
    } else {
      reviewOrder({
        amountEditOrderConfig,
        orderType,
        interPickUpDetails,
        deliveryDetails,
        deliveryBusiness,
        selectedDateTime,
        availableTimes,
        dateTimeToShow,
        updateOrderSettingModalIsVisible,
        specialHours,
        interPickUpDetails,
        interDeliveryDetails,
        interDropOffDetails,
        dropOffDetails,
      });
      updateCartScreen('review');
    }
  };
  if (cartReducer.products.length || cartReducer.combos.length) {
    return (
      <ReviewOrderButton
        isFoodRequired={isFoodRequired}
        handleClick={handleClick}
        totalCartPriceBeforeTax={formattedTotalCartPriceBeforeTax(
          cartReducer.products,
          cartReducer.combos
        )}
        updateCartScreen={updateCartScreen}
      />
    );
  } else {
    return null;
  }
};

const mapStateToProps = (state) => ({
  cartReducer: state.cartReducer,
  amountEditOrderConfig: state.orderSettingReducer.amountEditOrderConfig,
  orderingClosedInAllLocations:
    state.locationsReducer.orderingClosedInAllLocations,
  productsInCart: state.cartReducer.products,
  orderSettingReducer: state.orderSettingReducer,
  locations: state.locationsReducer.locations,
});

export default connect(mapStateToProps, {
  updateOrderSettingModalIsVisible,
  getTimeIntervalsDate,
})(ReviewOrderButtonContainer);
